import { useState } from 'react'
import { trackButtonClick, trackContactClick } from '../analytics'

export const useContactForm = (messages = {}) => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" })
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [submitError, setSubmitError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const requiredError = messages.required || "모든 필드를 입력해주세요."
  const invalidEmailError = messages.invalidEmail || "유효한 이메일 주소를 입력해주세요."
  const submitFailedError = messages.submit || "메시지 전송 중 오류가 발생했습니다."
  const networkError = messages.network || "네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요."

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const validateForm = () => {
    if (!formData.name || !formData.email || !formData.message) {
      setSubmitError(requiredError)
      return false
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setSubmitError(invalidEmailError)
      return false
    }
    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitError("")
    setIsSubmitted(false)
    setIsLoading(true)

    if (!validateForm()) {
      setIsLoading(false)
      return
    }

    trackButtonClick('contact_form_submit', 'contact_section')

    try {
      const response = await fetch(
        "https://asia-northeast3-codegrove-site.cloudfunctions.net/sendContactEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      )

      const result = await response.json()

      if (response.ok && result.success) {
        setIsSubmitted(true)
        setFormData({ name: "", email: "", message: "" })
        trackContactClick('form_success')
      } else {
        setSubmitError(result.error || submitFailedError)
        trackContactClick('form_error')
      }
    } catch (error) {
      console.error("Error sending email:", error)
      setSubmitError(networkError)
      trackContactClick('form_network_error')
    } finally {
      setIsLoading(false)
    }
  }

  return {
    formData,
    isSubmitted,
    submitError,
    isLoading,
    handleChange,
    handleSubmit
  }
}
